module.exports = __webpack_public_path__ + "assets/img/1b5dc1985e4f26af3ccae46ee0f9ad99.png";